import { motion } from "framer-motion";
import classNames from "classnames/bind";

import styles from "./ProgressBar.module.scss";

const cx = classNames.bind(styles);

export interface ProgressBarProps {
  className?: string;
  currentStep: number;
  color?: string;
  steps: number;
}

export const ProgressBar = ({ steps, color, currentStep, className }: ProgressBarProps) => (
  <div className={cx("progressBar", className)}>
    <motion.div
      className={styles.progressStatus}
      style={{ backgroundColor: color }}
      initial={{ width: 0 }}
      animate={{
        width: `${(currentStep / steps) * 100}%`,
      }}
    />
  </div>
);
